import {Http} from 'vue-resource'
import config from '../config'

class IntakeService {
  auth (intakeId, token) {
    return Http.post(config.API_URL + 'api/intakes/auth', {intake_id: intakeId, token}, {emulateJSON: true})
  }

  getPullFactors (postData) {
    return Http.post(
      config.API_URL + 'api/intakes/pull-factors', postData, {emulateJSON: true}
    )
  }
}

const instance = new IntakeService()

export default instance
